export const Bio = {
  name: "Marouane Debbagh",
  roles: [
    "Full Stack Developer",
    "Android Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    " I'm deeply passionate about DevOps and Fullstack Engineering. I thrive on challenges and constantly seek innovative solutions to optimize processes. The synergy between development and operations fascinates me, and I'm dedicated to staying ahead in this dynamic field. Let's dive in and make a difference!",
  github: "https://github.com/marouaneDebb",
  resume:
    "https://drive.google.com/file/d/1IUj9gl5AiQ9b__xPO0JdYBpKfCmOT_lh/view?usp=drive_link",
  linkedin: "www.linkedin.com/in/marouane-debbagh-7a6546275",
  twitter: "www.linkedin.com/in/marouane-debbagh-7a6546275",
  insta: "www.linkedin.com/in/marouane-debbagh-7a6546275",
  facebook: "www.linkedin.com/in/marouane-debbagh-7a6546275",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Angular",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "spring boot",
        image:
          "https://www.studytonight.com/css/resource.v3/icons/subject/logo-java-spring.svg",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Django",
        image: "https://logodix.com/logo/1758841.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      // {
      //   name: "Kotlin",
      //   image:
      //     "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      // },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://avatars.githubusercontent.com/u/18133?s=280&v=4",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Kubernetes_logo_without_workmark.svg/1200px-Kubernetes_logo_without_workmark.svg.png",
      },
      // {
      //   name: "VS Code",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      // },
      {
        name: "Postman",
        image:
          "https://www.svgrepo.com/show/354202/postman-icon.svg",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      {
        name: "Figma",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Figma-logo.svg/1667px-Figma-logo.svg.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQo0Pr3hTrpe9vVeYQXcuNa7vqDTkRjJiWNKEZwPuP34vTxj9Ftms-LKuBnKJzb1fCeBU&usqp=CAU",
    role: "Fullstack Engineering Intern",
    company: "3D Smart Factory.",
    date: "July 2023 - September 2023",
    desc: "developing an AI-powered platform to process 3D scans from dentists. My task was to clean and color-code teeth groups for clearer interpretation. This experience honed my skills at the intersection of AI, 3D imaging",
    skills: [
      "react js",
      "three js",
      "django",
      "JavaScript",
    ],
    doc: "https://i.pinimg.com/736x/2d/98/bd/2d98bd0e1dd1d1c7a19b179f729423fb.jpg",
  },
  // {
  //   id: 0,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
  //   role: "Frontend Engineer Intern",
  //   company: "Neurobit",
  //   date: "June 2023 - Present",
  //   desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
  //   skills: [
  //     "ReactJS",
  //     "Redux",
  //     "NodeJs",
  //     "Material UI",
  //     "HTML",
  //     "CSS",
  //     "JavaScript",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  // },
  
];

export const education = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/C4D0BAQGVLbqGRW70pA/company-logo_100_100/0/1631331131548?e=1719446400&v=beta&t=3-2yQS_XxyxoodNEQ061IiIYRMIlu4TLOyHQNCkUtEk",
    school: "Mohammadia School of Engineers",
    date: "2022 - 2025",
    // grade: "8.71 CGPA",
    desc: "At Ecole Mohamadia, I am pursuing my engineering degree with a focus on computer science and digitalization. The educational framework I am immersed in provides a holistic and thorough learning experience, encompassing all the necessary skills for a thriving engineering career. Our program offers a diverse range of courses and subjects, ensuring a well-rounded foundation to cultivate an exceptional engineering profile.",
    degree: "Computer science and igitalization",
  },
];

export const projects = [
  {
    id: 9,
    title: "School ERP",
    date: "October 2023 - February 2024",
    description:
      "created a School ERP system facilitating streamlined school payments and empowering parents to assign new services to their children effortlessly. This project enhanced communication between schools and parents while optimizing administrative processes, fostering a more efficient educational environment.",
    image:
      "https://i.pinimg.com/736x/ec/15/8d/ec158db0d2e5e0426d07b88bb562eb1b.jpg",
    tags: [
      "Docker",
      "Ionic",
      "Spring Boot",
      "bootstrap 5",
      "mysql",
      "react js",
    ],
    category: "web app",
    github: "https://github.com/marouaneDebb/ERP_Project",
    webapp: "https://marouanedebb.github.io/ERP_Project/",
    member: [
      {
        name: "Marouane Debbagh",
        img: "https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg?t=st=1711218606~exp=1711222206~hmac=eee5990e40b08172d8084e7aa5f9c3022d5e6a723ef1484d21a2ee2d981fa89c&w=740",
        linkedin: "https://www.linkedin.com/in/marouane-debbagh-7a6546275/",
        github: "https://github.com/marouaneDebb",
      },
      {
        name: "Youssef Oudourouch",
        img: "https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg?t=st=1711218606~exp=1711222206~hmac=eee5990e40b08172d8084e7aa5f9c3022d5e6a723ef1484d21a2ee2d981fa89c&w=740",
        linkedin: "https://www.linkedin.com/in/youssef-oudourouch-191476254/",
        github: "https://github.com/OUDOUROUCH-Youssef",
      },
    ],
  },
  {
    id: 0,
    title: "IPTV movies app",
    date: "Novembre 2023 - January 2024",
    description:
      "developed a full-stack application for movie enthusiasts, integrating the TMDB API for a vast selection of films. This project seamlessly combines front-end and back-end technologies to provide users with a smooth movie-watching experience.",
    image:
      "https://i.pinimg.com/736x/29/14/cf/2914cf0779fd247d0f12b2a58f147e9a.jpg",
    tags: [
      "Docker",
      "Angular",
    "Spring Boot",
    "bootstrap 5",
    "mysql", "Node Js",
  ],
    category: "web app",
    github: "https://github.com/marouaneDebb/Front_End-IPTV-source_code-",
    webapp: "https://github.com/marouaneDebb/Front_End-IPTV-source_code-",
  },
  {
    id: 1,
    title: "Ai-powered 3D tooth recognition",
    date: "July 2023 - September 2023",
    description:
      "developing an AI-powered platform to process 3D scans from dentists. My task was to clean and color-code teeth groups for clearer interpretation. This experience honed my skills at the intersection of AI, 3D imaging.",
    image:
      "https://i.pinimg.com/736x/2d/98/bd/2d98bd0e1dd1d1c7a19b179f729423fb.jpg",
    tags: [
      "react js",
      "three js",
      "django",
      "JavaScript",
    ],
    category: "web app",
    github: "https://github.com/marouaneDebb/3D.S.F_stage",
    webapp: "https://github.com/marouaneDebb/3D.S.F_stage",
    member: [
      {
        name: "Marouane Debbagh",
        img: "https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg?t=st=1711218606~exp=1711222206~hmac=eee5990e40b08172d8084e7aa5f9c3022d5e6a723ef1484d21a2ee2d981fa89c&w=740",
        linkedin: "https://www.linkedin.com/in/marouane-debbagh-7a6546275/",
        github: "https://github.com/marouaneDebb",
      },
      {
        name: "Youssef Oudourouch",
        img: "https://img.freepik.com/free-vector/illustration-businessman_53876-5856.jpg?t=st=1711218606~exp=1711222206~hmac=eee5990e40b08172d8084e7aa5f9c3022d5e6a723ef1484d21a2ee2d981fa89c&w=740",
        linkedin: "https://www.linkedin.com/in/youssef-oudourouch-191476254/",
        github: "https://github.com/OUDOUROUCH-Youssef",
      },
    ],
  },
  {
    id: 2,
    title: "snake game",
    date: "April 2023 - May 2023",
    description:
      "",
    image:
      "https://i.pinimg.com/736x/ba/01/d2/ba01d24e7b625900abb75b1818c448c4.jpg",
    tags: ["Java", "Mysql", "Javafx"],
    category: "desktop application",
    github: "https://github.com/marouaneDebb/snakeGame-java",
    webapp: "https://github.com/marouaneDebb/snakeGame-java",
  },
  
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
